<template>
    <div class="mb-4">
        <div id="select-tags" class="">
            <autocomplete-addable
                aria-label="add tags"
                id="add-tags"
                v-model="selectedValues"
                :label="t_tags"
                :items="fullTagList.data"
                :popup-used-in-modal="true"
                :outlined="true" :dense="true" hide-details="auto"
                :multiple="true"
                clearable
                :creatable-values="tagCreationPrivilege === '1'">
            </autocomplete-addable>
        </div>
    </div>
</template>

<script>
    import toaster from "../../../common/toaster";

    export default {
        props: ['currentTags', 'allTags', 'tagCreationPrivilege'],
        data: function () {
            return {
                t_tags: Lang.langGet("Add tags to media"),
                t_load_failed: Lang.langGet("Failed to load tags from database."),
                fullTagList: {data: this.allTags},
                selectedValues: this.currentTags
            }
        },
        watch: {
            selectedValues: {
                handler: function () {
                    this.$emit('currentTagsUpdated', this.selectedValues);
                },
                deep:true
            }
        },
        methods: {
            loadTags: function () {
                if (this.fullTagList.data.length > 0) {
                    return;
                }

                axios.post('/content/mediapool/loadtags', {
                    id: Laravel.activeProject
                }).then((response) => {
                    this.fullTagList.data = response.data.data.ordinaryTags;
                    this.$emit('allTagsUpdated', this.fullTagList);
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    toaster.error(this.t_load_failed);
                });
            },
        },
        mounted() {
            this.loadTags();
        }
    }
</script>
